if (!customElements.get('cart-drawer-recommendations')) {
  class CartDrawerRecommendations extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      if (!this.dataset.url) return;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    removeRecommendations() {
      const wrapper = this.closest('.cart-drawer-recommendations');
      if (wrapper) {
        wrapper.remove();
        return;
      }

      this.remove();
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const content = html.querySelector('.cart-drawer-recommendations__slider');
          const wrapper = this.closest('[data-slider-wrapper]');

          if (content && content.querySelector('.cart-drawer-recommendations__item')) {
            this.replaceWith(content);

            if (wrapper && window.SliderWrapper?.init) {
              window.SliderWrapper.init(wrapper);
            }
          } else {
            this.removeRecommendations();
          }
        })
        .catch((error) => {
          console.error(error);
          this.removeRecommendations();
        });
    }
  }

  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
